import React, { useEffect, useContext } from "react";
import api from "axios_interceptor/interceptor";
import {
  Text,
  Flex,
  Heading,
  Card,
  Box,
  Separator,
  IconButton,
  Spinner,
} from "@radix-ui/themes";
import { QueueViewContext } from "context/QueueViewContext";
import { ReloadIcon } from "@radix-ui/react-icons";

function timeAgo(dateString) {
  const givenDate = new Date(Date.parse(dateString + " UTC")); 
  const now = new Date(); 
  const diffMs = now - givenDate; 

  const diffMinutes = Math.floor(diffMs / (1000 * 60)); 
  const diffHours = Math.floor(diffMinutes / 60); 

  if (diffMinutes < 1) {
    return "now";
  } else if (diffMinutes <= 9) {
    return `${diffMinutes} minute ago`;
  } else if (diffMinutes < 60) {
    return `${diffMinutes} minutes ago`;
  } else if (diffHours <= 9) {
    return `${diffHours} hour ago`;
  } else if (diffHours < 24) {
    return `${diffHours} hours ago`;
  } else {
    const day = givenDate.getDate();
    const month = givenDate.toLocaleString("default", { month: "long" });
    return `${day} ${month}`;
  }
}

const QueueView = () => {
  const { currentQueueView, setCurrentQueueView } =
    useContext(QueueViewContext);

  useEffect(() => {
    fetchAudioStatus();
    const intervalId = setInterval(() => {
      fetchAudioStatus();
    }, 60 * 1000); // Poll every 60 second

    return () => clearInterval(intervalId); // Cleanup interval on unmount
  }, []);

  const fetchAudioStatus = async () => {
    try {
      const response = await api.post("/utils/audio-check-by-user");
      const audioQueue = response.data.content;
      setCurrentQueueView(audioQueue);
    } catch (error) {
      console.error("Error fetching audio status:", error);
    }
  };

  const handleOnClickReloadButton = () => {
    fetchAudioStatus();
  };

  // Sort the queue, most recent first.
  const sortedQueueView = currentQueueView.sort((a, b) => {
    return new Date(b.created_at) - new Date(a.created_at);
  });

  return (
    <Card size="3">
      <Flex align="center" justify="between" mb="5">
        <Heading as="h3" size="4" trim="both">
          Queue
        </Heading>

        <Flex my="-1" gap="4">
          <IconButton
            style={{ cursor: "pointer" }}
            color="gray"
            onClick={handleOnClickReloadButton}
          >
            <ReloadIcon color="black" />
          </IconButton>
        </Flex>
      </Flex>

      {currentQueueView.length === 0 ? (
        <Flex direction="column" gap="4">
          <Flex align="center" gap="3">
            <Box>
              <Text>Queue is empty. Create an audio and get listening!</Text>
            </Box>
          </Flex>
        </Flex>
      ) : (
        sortedQueueView.map((data, i) => (
          <div key={i}>
            <Flex direction="row" gap="4" justify="between">
              <Flex style={{ flex: 6 }}>
                <Text as="div" size="2">
                  {data.topic}
                </Text>
              </Flex>

              <Flex style={{ flex: 1, justifyContent: "center" }}>
                <Text as="div" size="2">
                  {/* Timezone ??*/}
                  {timeAgo(data.created_at)}
                </Text>
              </Flex>

              <Flex style={{ flex: 1, justifyContent: "flex-end" }}>
                <Text as="div" size="2" color="gray">
                  {data.status === "COMPLETE" ? (
                    <Flex>
                      <Text color="green">Finished</Text>
                    </Flex>
                  ) : (
                    <Flex gap="2">
                      <Spinner />
                      <Text color="orange">Generating</Text>
                    </Flex>
                  )}
                </Text>
              </Flex>
            </Flex>
            <Separator
              size="4"
              style={{ marginTop: "5px", marginBottom: "5px" }}
            ></Separator>
          </div>
        ))
      )}
    </Card>
  );
};

export default QueueView;
